import api from './api';

const transactionService = {
  getAll: async () => {
    const response = await api.get('/transactions');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/transactions/${id}`);
    return response.data;
  },
  
  create: async (transaction) => {
    const response = await api.post('/transactions', transaction);
    return response.data;
  },
  
  update: async (id, transaction) => {
    const response = await api.put(`/transactions/${id}`, transaction);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/transactions/${id}`);
    return response.data;
  },
  
  search: async (filters) => {
    const response = await api.get('/transactions/search', { params: filters });
    return response.data;
  },
  
  importText: async (content) => {
    const response = await api.post('/transactions/import', content, {
      headers: {
        'Content-Type': 'text/plain'
      }
    });
    return response.data;
  },

  importCreditCard: async (creditCardId, content) => {
    const response = await api.post(`/transactions/import/credit-card/${creditCardId}`, content, {
      headers: {
        'Content-Type': 'text/plain'
      }
    });
    return response.data;
  },

  getRecurrenceGroup: async (groupId) => {
    const response = await api.get(`/transactions/recurrence/${groupId}`);
    return response.data;
  },

  updateRecurrenceGroup: async (groupId, data) => {
    const response = await api.put(`/transactions/recurrence/${groupId}`, data);
    return response.data;
  },

  deleteRecurrenceGroup: async (groupId) => {
    const response = await api.delete(`/transactions/recurrence/${groupId}`);
    return response.data;
  },

  extendRecurrence: async (groupId, count = 12) => {
    const response = await api.post(`/transactions/recurrence/${groupId}/extend?count=${count}`);
    return response.data;
  }
};

export default transactionService; 